"use client";

import { useSnapshot } from "valtio";
import { AccountState } from "../../stores/accountStore";
export function useHasAcceptedTerms() {
  const {
    hasAcceptedTerms
  } = useSnapshot(AccountState);
  return hasAcceptedTerms;
}